import { useState } from "react";
import { MapPin, Loader2, AlertTriangle, CheckCircle2 } from "lucide-react";
import { api } from "./api";

export const uploadFile = (url, file, fields, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(fields || {}).forEach(([k, v]) => fd.append(k, v));
  return api.post(url, fd, {
    onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded * 100) / e.total) : 0),
  });
};

export const useGps = () => {
  const [state, setState] = useState({ status: "idle" });
  const capture = () => {
    if (!navigator.geolocation) return setState({ status: "unsupported" });
    setState({ status: "loading" });
    navigator.geolocation.getCurrentPosition(
      (p) => setState({
        status: "ok",
        gps: { latitude: p.coords.latitude, longitude: p.coords.longitude, accuracy: Math.round(p.coords.accuracy), capturedAt: new Date(p.timestamp).toISOString() },
      }),
      (err) => setState({ status: err.code === 1 ? "denied" : "error", message: err.message }),
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  };
  return [state, capture];
};

export const GpsInfo = ({ gps, testid = "gps-info" }) =>
  gps ? (
    <p className="text-sm text-emerald-800 flex items-start gap-1.5" data-testid={testid}>
      <CheckCircle2 className="h-4 w-4 mt-0.5 shrink-0" />
      <span>
        GPS TEREKAM: <span className="font-mono break-all">{gps.latitude.toFixed(6)}, {gps.longitude.toFixed(6)}</span>
        {gps.accuracy != null && ` (±${gps.accuracy} m)`} · {new Date(gps.capturedAt).toLocaleString("id-ID")}
      </span>
    </p>
  ) : (
    <p className="text-sm text-slate-500" data-testid={testid}>Lokasi belum diambil.</p>
  );

const GPS_MSG = {
  denied: "Izin lokasi ditolak. Aktifkan izin lokasi untuk browser ini di pengaturan HP, lalu coba lagi.",
  error: "Lokasi tidak dapat diambil. Pastikan GPS aktif dan coba lagi di area terbuka.",
  unsupported: "Perangkat ini tidak mendukung pengambilan lokasi.",
};

export const GpsCapture = ({ state, capture, current }) => (
  <div className="space-y-3">
    <button type="button" onClick={capture} disabled={state.status === "loading"}
      className="w-full h-14 rounded-xl bg-emerald-800 hover:bg-emerald-900 text-white font-bold tracking-wide flex items-center justify-center gap-2 disabled:opacity-70"
      data-testid="gps-capture-btn">
      {state.status === "loading" ? <Loader2 className="h-5 w-5 animate-spin" /> : <MapPin className="h-5 w-5" />} AMBIL LOKASI SEKARANG
    </button>
    {GPS_MSG[state.status] && (
      <p className="rounded-lg bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-900 flex gap-2" data-testid="gps-warning">
        <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" /> {GPS_MSG[state.status]}
      </p>
    )}
    <GpsInfo gps={state.gps || current} />
  </div>
);
